export default __webpack_public_path__ + "static/media/ach_check.392b73cc.png";